// toastMessage.js
export const getRenderMsg = (id, type) => {
    const renderMsg = {
        success: {
            SAVE: "저장이 완료되었습니다.",
            DEL: "삭제가 완료되었습니다.",
            DEFAULT: "조회가 완료되었습니다.",
        },
        error: {
            SAVE: "저장에 실패하였습니다.",
            DEL: "삭제를 실패하였습니다.",
            DEFAULT: "오류가 발생하였습니다.",
        },
        warning: {
            SAVE: "저장에 실패하였습니다.",
            DEL: "삭제를 실패하였습니다.",
            DEFAULT: "검색 결과가 없습니다.",
        },
    };
    const upperId = id?.toUpperCase() || "DEFAULT";
    return renderMsg[type]?.[upperId] || renderMsg[type]?.DEFAULT;
};

export const getLoadMsg = (id) => {
    const loadMsg = {
        SAVE: "저장 중입니다...",
        DEL: "삭제 중입니다...",
        DEFAULT: "처리 중입니다...",
    };
    const upperId = id?.toUpperCase() || "DEFAULT";
    return loadMsg[upperId] || loadMsg.DEFAULT;
};
